import { render, staticRenderFns } from "./motion.vue?vue&type=template&id=4287490e&scoped=true&"
import script from "./motion.vue?vue&type=script&lang=js&"
export * from "./motion.vue?vue&type=script&lang=js&"
import style0 from "./motion.vue?vue&type=style&index=0&id=4287490e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4287490e",
  null
  
)

export default component.exports